<template>
  <div class="loginPage">
    <div class="loginColumn">
      <img class="loginLogo" src="@/assets/searchLogo.svg" />
      <img class="loginImage" src="@/assets/loginIcon.png" />
      <img class="loginLogoText" src="@/assets/CourseLnk.png" />
    </div>
    <div class="loginColumn">
      <form @submit.prevent="resetPassword" class="loginForm">
        <p class="loginTitle">Forgot Password?</p>
        <p>
          Enter your new password
        </p>
        <div class="signUpNames">
          <div class="user-input-wrp">
            <input
              v-model="password"
              type="password"
              placeholder=" "
              name="password"
              required
              class="inputText"
            />
            <span class="floating-label">New Password</span>
          </div>
          <p v-if="feedback" class="feedback">{{ feedback }}</p>
        </div>
        <div class="endFormLogin">
          <button type="submit" class="joinButtonSmall">Reset</button>
        </div>

        <div class="loginSignupDivider"></div>
        <div class="signupBox">
          <router-link class="joinButtonSmall toSignup" :to="{ name: 'Login' }"
            >Back to login</router-link
          >
        </div>
      </form>
    </div>
    <div class="bottomNav">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <router-link
        class="landingButton"
        :to="{
          name: 'Landingpage',
        }"
        >About</router-link
      >
      <router-link
        class="landingButton"
        :to="{ name: 'Terms' }"
        target="_blank"
      >
        Terms and Conditions
      </router-link>
      <router-link
        class="landingButton"
        :to="{ name: 'Privacy' }"
        target="_blank"
      >
        Privacy Policy
      </router-link>
      <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
        Join the team
      </router-link>
    </div>
    <div class="bottomNavSmall">
      <p class="landingButtonHoverless">CourseLnk © 2021</p>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{
            name: 'Landingpage',
          }"
          >About</router-link
        >
        <router-link class="landingButton" :to="{ name: 'Ambassadors' }">
          Join the team
        </router-link>
      </div>
      <div class="bottomColumn">
        <router-link
          class="landingButton"
          :to="{ name: 'Terms' }"
          target="_blank"
        >
          Terms and Conditions
        </router-link>
        <router-link
          class="landingButton"
          :to="{ name: 'Privacy' }"
          target="_blank"
        >
          Privacy Policy
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import { mapState } from "vuex";

export default {
  name: "SetPassword",

  data() {
    return {
      password: null,
      feedback: null,
    };
  },

  computed: {
    ...mapState("setPassword", ["actionCode"]),
  },

  methods: {
    resetPassword() {
      firebase
        .auth()
        .verifyPasswordResetCode(this.actionCode)
        .then((email) => {
          var accountEmail = email;
          console.log(accountEmail);
          // TODO: Show the reset screen with the user's email and ask the user for
          // the new password.

          // Save the new password.
          firebase
            .auth()
            .confirmPasswordReset(this.actionCode, this.password)
            .then((resp) => {
              console.log(resp);
              this.$router.push({ name: "NewPassword" });
              // Password reset has been confirmed and new password updated.
              // TODO: Display a link back to the app, or sign-in the user directly
              // if the page belongs to the same domain as the app:
              // auth.signInWithEmailAndPassword(accountEmail, newPassword);
              // TODO: If a continue URL is available, display a button which on
              // click redirects the user back to the app via continueUrl with
              // additional state determined from that URL's parameters.
            })
            .catch((error) => {
              console.log(error);

              // Error occurred during confirmation. The code might have expired or the
              // password is too weak.
            });
        })
        .catch((error) => {
          console.log(error);

          // Invalid or expired action code. Ask user to try to reset the password
          // again.
        });
    },
  },
};
</script>

<style scoped src="@/styles/components/auth/Login.css"></style>
